import {useEffect, useRef} from 'react';
import {useSelector} from 'react-redux';
import {highlightedElementIndexSelector, selectedSlideSelector} from '../../store/selectors/slide.selectors';
import {useEmptyModalElementCleanup} from './useEmptyModalElementCleanup';
import {useEmptyTextElementCleanup} from './useEmptyTextElementCleanup';

export const useElementCleanup = (): void => {
    const slide = useSelector(selectedSlideSelector);

    const textCleanup = useEmptyTextElementCleanup();
    const modalCleanup = useEmptyModalElementCleanup();

    const highlightedElementIndex = useSelector(highlightedElementIndexSelector);
    const previousIndexRef = useRef(highlightedElementIndex);

    useEffect(() => {
        const oldIndex = previousIndexRef.current;
        previousIndexRef.current = highlightedElementIndex;

        if (oldIndex < 0) return;
        const oldElement = slide.elements[oldIndex];

        if (oldIndex === highlightedElementIndex) return;
        if (!oldElement) return;

        textCleanup(oldElement, oldIndex);
        modalCleanup(oldElement, oldIndex);
    }, [highlightedElementIndex, modalCleanup, slide.elements, textCleanup]);
};
